var map = {
	"./subnav.de-CH.json": 1338,
	"./subnav.de-DE.json": 1339,
	"./subnav.en-CA.json": 1340,
	"./subnav.en-GB.json": 1341,
	"./subnav.en-IN.json": 1342,
	"./subnav.en-ME.json": 1343,
	"./subnav.en-US.json": 1344,
	"./subnav.es-EM.json": 1345,
	"./subnav.es-ES.json": 1346,
	"./subnav.fr-BE.json": 1347,
	"./subnav.fr-CA.json": 1348,
	"./subnav.fr-CH.json": 1349,
	"./subnav.nl-BE.json": 1350,
	"./subnav.nl-NL.json": 1351,
	"./subnav.pl-PL.json": 1352,
	"./subnav.pt-BR.json": 1353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1337;